import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Models
import { ICalendarEventType } from "app/models/CalendarEvent";
// Types
import Reducers from 'app/types/Reducers';
// Async
import {
  createCalendarEventType, deleteCalendarEventType, getCalendarEventTypes,
  getCalendarEventType, updateCalendarEventType
} from "./CalendarEventTypesAsync";

interface IState {
  eventType: ICalendarEventType | null;
  eventTypes: ICalendarEventType[] | null;
};

const initialState:IState = {
  eventType: null,
  eventTypes: null
};

const slice = createSlice({
  name: Reducers.CalendarEvents,
  initialState,
  reducers: {
    // Default
    setInitialField: <IStateKey extends keyof IState>(state: IState, action: PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    }
  },
  extraReducers(builder) {
    builder.addCase(getCalendarEventTypes.fulfilled, (state, action: PayloadAction<ICalendarEventType[]>) => {
      state.eventTypes = action.payload;
    })
    builder.addCase(getCalendarEventType.pending, (state) => {
      state.eventType = null;
    });
    builder.addCase(getCalendarEventType.fulfilled, (state, action:PayloadAction<ICalendarEventType>) => {
      state.eventType = action.payload;
    });
    builder.addCase(createCalendarEventType.fulfilled, (state, action:PayloadAction<ICalendarEventType>) => {
      if ( state.eventTypes ){
        state.eventTypes.push(action.payload);
      }
    });
    builder.addCase(updateCalendarEventType.fulfilled, (state, action:PayloadAction<ICalendarEventType>) => {
      if ( state.eventTypes ){
        state.eventTypes = state.eventTypes.map(eventType => {
          if ( eventType.id === action.payload.id ) return action.payload;
          return eventType;
        })
      }
    });
    builder.addCase(deleteCalendarEventType.fulfilled, (state, action:{ payload:number }) => {
      if ( state.eventTypes ){
        state.eventTypes = state.eventTypes.filter(eventType => eventType.id !== action.payload);
      }
    });
  },
});

export const CalendarEventTypesActions = slice.actions;

export default slice.reducer;
